(function() {
    'use strict';

    angular
        .module('abcQualityMatchApp')
        .controller('FactoryDeleteController',FactoryDeleteController);

    FactoryDeleteController.$inject = ['$uibModalInstance', 'entity', 'Factory'];

    function FactoryDeleteController($uibModalInstance, entity, Factory) {
        var vm = this;

        vm.factory = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Factory.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
